import { useTranslation, Trans } from 'react-i18next';
import { useGetRestaurantIdentityQuery } from '@/app/api/hubApi';

interface Props {
  restaurantUuid: string;
}

export default function CancellationPolicyNotice({ restaurantUuid }: Props) {
  const { t } = useTranslation();
  const { data: identity, isLoading } = useGetRestaurantIdentityQuery(restaurantUuid, {
    skip: !restaurantUuid,
  });

  if (isLoading) return null;

  const phone = identity?.phone ?? null;

  return (
    <div
      data-testid="cancellation-policy-notice"
      role="alert"
      className="border-2 border-red-600 bg-red-50 rounded-btn-sm px-4 py-3 font-mono text-sm text-red-800 shadow-stamp-sm"
    >
      <p className="m-0 leading-relaxed">
        <span aria-hidden="true" className="me-1 text-base">⚠️</span>
        <strong className="font-bold uppercase">
          {t('restaurant.cancellation.cannotCancel')}
        </strong>{' '}
        {phone ? (
          <Trans
            i18nKey="restaurant.cancellation.callTo"
            values={{ phone }}
            components={{
              tel: (
                <a
                  href={`tel:${phone}`}
                  className="font-bold underline text-red-900 whitespace-nowrap"
                />
              ),
            }}
          />
        ) : (
          t('restaurant.cancellation.contactDirectly')
        )}
      </p>
    </div>
  );
}
